import StorageRepository from '../../Domain/Repositories/StorageRepository';
class CookieRepository extends StorageRepository {
  constructor(cookieService) {
    super();
    this.cookieService = cookieService;
  }
  set(key, value, expires) {
    this.cookieService.set(key, value, {
      expires
    });
  }
  get(key) {
    return this.cookieService.get(key);
  }
  isExpired(key) {
    return !!this.cookieService.check(key);
  }
  remove(key) {
    this.cookieService.delete(key);
  }
}

export { CookieRepository as default };